const StudyOption = [
  {
    _id: { $oid: "68bfc8751e31918280ae47c0" },
    name: "All Users",
    id: "allusers",
    link: "/all-users-data",
    symbol: "👥",  
    status: "true",
    description: "View all registered users"
  },
  {
    _id: { $oid: "68aea2a1ac23b33a6c17d759" },
    name: "Users Before Login",
    id: "usersbeforelogin",
    link: "/all-users-before-login",
    symbol: "🚪", 
    status: "true",
    description: "Users who visited but didn't register"
  },
  {
    _id: { $oid: "68aea2a1ac23b33a6c17d75b" },
    name: "App Install Users",
    id: "appinstallusers",
    link: "/app-install-users",
    symbol: "📱",  
    status: "true",
    description: "Users who installed the app"
  },
   {
    _id: { $oid: "68aea2a1ac23b33a6c17d3io" },
    name: "App Items Use",
    id: "appinstallusers",
    link: "/app-items-use",
    symbol: "📦",  
    status: "true",
    description: "Users who installed the app"
  },
  {
    _id: { $oid: "68bfc6dd1e31918280ae47a5" },
    name: "All Payment Items",
    id: "allpaymentitems",
    link: "/all-payment-items",
    symbol: "🛒",  
    status: "true",
    description: "Manage payment items and products"
  },
  {
    _id: { $oid: "68bfbb7a1e31918280ae46cf" },
    name: "All Payments",
    id: "allpayments",
    link: "/all-payments",
    symbol: "💳",  
    status: "true",
    description: "View all payment transactions"
  },
  {
    _id: { $oid: "68bfbb991e31918280ae46d2" },
    name: "Student Doubts",
    id: "studentdoubts",
    link: "/report-question",
    symbol: "❓", 
    status: "true",
    description: "Manage student questions and doubts"
  },
  {
    _id: { $oid: "68aea2a1ac23b33a6c17d762" },
    name: "Student Messages",
    id: "studentmessages",
    link: "/student-messages",
    symbol: "💬",  
    status: "true",
    description: "View and respond to student messages"
  }
];

export default StudyOption;